const isAndroid = () =>
  Boolean((window as any).navigator.userAgent.match(/Android/i));
const isIos = () =>
  Boolean((window as any).navigator.userAgent.match(/iPhone|iPad|iPod/i));
const isOpera = () =>
  Boolean((window as any).navigator.userAgent.match(/Opera Mini/i));
const isWindows = () =>
  Boolean((window as any).navigator.userAgent.match(/IEMobile/i));
const isSSR = () => Boolean((window as any).navigator.userAgent.match(/SSR/i));
const isMobile = () =>
  Boolean(isAndroid() || isIos() || isOpera() || isWindows());
const isDesktop = () => Boolean(!isMobile() && !isSSR());

export { isMobile, isDesktop, isAndroid, isIos, isSSR };
